import React from 'react';

const PageNotFound = () => {
  return (
    <div>
      404 not found
    </div>
  );
}

export default PageNotFound;
